const success = {
  path: 'success',
  component: resolve => require(['@/pages/admin/reviewed/wechat/accessPay/success'], resolve)
}

export default success
